import { render } from "./RecommendationsView.vue?vue&type=template&id=6c9e029a&scoped=true"
import script from "./RecommendationsView.vue?vue&type=script&lang=js"
export * from "./RecommendationsView.vue?vue&type=script&lang=js"

import "./RecommendationsView.vue?vue&type=style&index=0&id=6c9e029a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9e029a"]])

export default __exports__